<template>
    <div>
        <v-data-table
                :headers="headers"
                :items="players"
                class="elevation-1"
                item-key="username"
                disable-initial-sort
                :pagination.sync="pagination"
                :rowsPerPageItems="[10]"
        >
            <template slot="items" slot-scope="props">
                <tr @click="getPlayerDetail(props)">
                    <td>{{ props.item.rank}}</td>
                    <td><router-link :to="`/player/${server}/${props.item.playerId}`">{{ props.item.username }}</router-link></td>
                    <td><router-link :to="`/fellowship/${server}/${props.item.fellowshipId}`">{{ props.item.fellowship }}</router-link></td>
                    <td>{{ props.item.points }}</td>
                </tr>
            </template>
            <!--<template slot="expand" slot-scope="props">-->
                <!--<v-card flat>-->
                    <!--<v-card-text v-if="props.item.finishedRequest">-->
                    <!--<div>-->
                        <!--wait a sec-->
                        <!--<div v-if="props.item.moreInfo">-->
                            <!--<strong>{{ $t('site.common.chapter') }}</strong>: {{props.item.moreInfo.technologySection}}-->
                            <!--<strong>{{ $t('site.common.score') }}</strong>: {{props.item.moreInfo.currScore}}-->
                        <!--</div>-->
                    <!--</div>-->
                    <!--</v-card-text>-->
                <!--</v-card>-->
            <!--</template>-->
            <template slot="no-data">
                <v-alert :value="true" color="error" icon="warning">
                    Sorry, nothing to display here :(
                </v-alert>
            </template>
        </v-data-table>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: 'elv-tournament-player-table',
        props: {
            "players": { required: true },
            "server": { required: true },
        },
        data () {
            return {
                pagination: {
                    sortBy: 'points',
                    descending:true,
                    rowsPerPage: 10,
                    expandProgress: false,
                    expandPlayer: {},
                },
            }
        },
        mounted() {

        },
        computed: {
            headers: {
                get: function () {
                    return [
                        { text: this.$i18n.t('site.fellowship.stats.rank'), align: 'left', sortable: false, value: 'rank'},
                        { text: this.$i18n.t('site.common.username'), align: 'left', sortable: false, value: 'username'},
                        {
                            text: this.$i18n.t('site.common.fellowship'),
                            align: 'left',
                            sortable: false,
                            value: 'fellowship'
                        },
                        {text: this.$i18n.t('site.common.score'), value: 'points', sortable:false},
                    ];
                }
            },
        },
        methods: {
            getPlayerDetail: function(props) {
                console.log("progress on");
                props.item.finishedRequest= false;
                let self = this;
                props.expanded = !props.expanded;
                axios.get(`/api/player/${props.item.server||this.server}/${props.item.playerId}`).then( (response) => {
                    try {
                        //console.log("PLAYER RESPONSE", response);
                        props.item.moreInfo = response.data;
                        //this.scoreHistoryChart = getScoreHistoryChart( this.player, this.$i18n );
                        //this.tournamentHistoryChart = getTournamentHistoryChart( this.player, this.$i18n );
                        //Event.$emit("ajaxError", "Error");
                        this.forceUpdate();
                    }catch(err) {
                        console.error(err);
                    }
                }).catch( (err) => {
                    console.log(err);
                }).finally( () => {
                    console.log("progress is off");
                    props.item.finishedRequest = true;
                });
            }
        }
    }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/ElvTournamentPlayerTable.vue